function setHint(msg, outElement) {
  outElement = outElement || this.hintOut;
  outElement.innerHTML = '';

  if (!msg) return;

  (Array.isArray(msg) ? msg : [msg]).map(message => {
    outElement.insertAdjacentHTML('beforeend', `
			<div class="${message.type}">
        <i class="fas ${message.type === 'alert' ? 'fa-exclamation-triangle alert' : 'fa-info-circle'}"></i>
        ${message.text}
      </div>
		`);
  });
}

export {
  setHint
}